var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,3.91666667 C34.29825,3.91666667 43.0833333,12.70175 43.0833333,23.5 C43.0833333,34.29825 34.29825,43.0833333 23.5,43.0833333 C12.70175,43.0833333 3.91666667,34.29825 3.91666667,23.5 C3.91666667,12.70175 12.70175,3.91666667 23.5,3.91666667 Z M23.5,0 C10.522125,0 0,10.522125 0,23.5 C0,36.477875 10.522125,47 23.5,47 C36.477875,47 47,36.477875 47,23.5 C47,10.522125 36.477875,0 23.5,0 Z M23.5,15.6666667 L23.5,22.9144583 C23.5,28.5094167 19.839875,32.2733333 14.6875,33.2916667 L13.71225,31.2099583 C16.0994583,30.3110833 17.630875,27.641875 17.630875,25.474 L13.7083333,25.474 L13.7083333,15.6666667 L23.5,15.6666667 Z M35.25,15.6666667 L35.25,22.9144583 C35.25,28.5094167 31.589875,32.2733333 26.4375,33.2916667 L25.46225,31.2099583 C27.8494583,30.3110833 29.380875,27.641875 29.380875,25.474 L25.4583333,25.474 L25.4583333,15.6666667 L35.25,15.6666667 Z",
    id: "Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote1);
export default __webpack_public_path__ + "static/media/Quote 1.36f194d7.svg";
export { ForwardRef as ReactComponent };